import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent {
@Input()from:any;
    @Output() selectedDay = new EventEmitter<any>();
    months: any = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
    weeks: any = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    dates: any = [];
    daysinMonth: any;
    paddingDays: any;
    monthName: any;
    currentDate = new Date();
    month = this.currentDate.getMonth();
    currentMonth = this.currentDate.getMonth();
    year = this.currentDate.getFullYear();
    currentyear=this.currentDate.getFullYear();
    today = this.currentDate.getDate();
    week = this.currentDate.getDay();
    firstDayMonth: any;
    
  
    selectedday:any;
  
    ngOnInit(): void {
      this.renderCalendar();
  
    }
    renderCalendar() {
      this.dates = [];
  
      this.daysinMonth = new Date(this.year, this.month + 1, 0).getDate();
      this.firstDayMonth = new Date(this.year, this.month, 1);
      this.monthName = this.months[this.firstDayMonth.getMonth()]
      this.paddingDays = this.firstDayMonth.getDay();
      this.displayDate();
  
    }
    displayDate() {
      let weekIndex = this.paddingDays;
      for (let i = 1; i <= this.paddingDays + this.daysinMonth; i++) {
        if (i <= this.paddingDays) {
  
          this.dates.push('');
  
        }
        else {
          this.dates.push({
            date: i - this.paddingDays,
            week: this.weeks[weekIndex],
            year: this.year,
            month: this.month,
            monthname: this.monthName
  
          })
          if (weekIndex >= 6) {
            weekIndex = 0;
          }
          else {
            weekIndex++;
          }
        }
  
      }
  
    }
  
    goToPreviousMonth() {
  
      if (this.month == 0) {
        this.year -= 1;
        this.month = 11;
        this.renderCalendar();
      }
      else {
        this.month -= 1;
        this.renderCalendar();
      }
    }
  
    goToNextMonth() {
      if (this.month == 11) {
        this.year += 1;
        this.month = 0;
        this.renderCalendar();
      }
      else {
        this.month += 1;
  
        this.renderCalendar();
  
  
      }
  
    }
    getSelectedDate(date: any) {
      // this.newItemEvent.emit({day:date,today:this.today});
      console.log(date);
  //  if(date.month==this.currentMonth && date.year==this.currentyear){
  //   if(date.date>=this.today){
  //     this.selectedDay.emit(date);
  //     this.selectedday=date;
  //   }
  //  }
    // else{
      this.selectedDay.emit(date);
      this.selectedday=date;
    // }    
    
  
      
    }
  
  }
  
  
  
  




